import ClientTagsSection from './ClientTagsSection';

export default ClientTagsSection;
